export const MODEL_UNAVAILABLE_ERROR_REASON = 'model_unavailable'

export type CreateMessageErrorReason = typeof MODEL_UNAVAILABLE_ERROR_REASON
